/** @jsx jsx */
import { jsx, css } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@blueprintjs/core';
import { Icon } from '/components/icon';
import Popup from './popup';
import { ColorAliases } from 'styles/variables';

/**
 * Icon and logic for creating multiselect popup.
 */
export const MultiSelect = ({ items = [], onClose, title, selected, minimumItems = 1 }) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleClose = (sortedSelections) => {
		setIsOpen(false);
		onClose(sortedSelections);
	};

	return (
		<React.Fragment>
			<Button cy-test="select-properties" css={facetDropdownStyles} minimal onClick={() => setIsOpen(true)}>
				<Icon icon="select" /> Select Properties
			</Button>
			{isOpen && (
				<Popup
					title={title}
					closeModal={(sortedSelections) => handleClose(sortedSelections)}
					items={items}
					initialSelected={selected}
					minimumItems={minimumItems}
				/>
			)}
		</React.Fragment>
	);
}; 

MultiSelect.propTypes = {
	/**
	 * Items for the multiselect modal.
	 */
	items: PropTypes.array,
	/**
	 * Items that start off as selected in the component.
	 * Optional, default behavior is start off with all items selected.
	 */
	selected: PropTypes.array,
	/**
	 * Function called when the modal is closed. Returns an object with the selected and unselected properties.
	 */
	onClose: PropTypes.func,
	/**
	 * This string is used as a title for the dialog.
	 */
	title: PropTypes.string,

	minimumItems: PropTypes.number,
};

const facetDropdownStyles = css`
	font-weight: bold;
	padding-top: 3px;

	.bp3-icon.bp3-icon-select:first-of-type {
		margin: 0;
	}
`;

export default MultiSelect; 
